import React from 'react';
import { Card } from '@/components/ui/card';
import { Construction } from 'lucide-react';

/**
 * Tab genérico "en desarrollo" usado por Inventarios, RRHH y Reembolsos.
 */
const PlaceholderTab = ({ titulo, descripcion }) => (
  <Card className='p-12 text-center border-slate-200 border-dashed'>
    <Construction className='w-16 h-16 text-slate-300 mx-auto mb-4' />
    <h3 className='text-xl font-semibold text-slate-600 mb-2'>{titulo}</h3>
    <p className='text-slate-500 max-w-md mx-auto'>{descripcion}</p>
  </Card>
);

export default PlaceholderTab;
